import { get } from "@services/apiService.js";

export default {
  getForms({ language }) {
    return get(`/v4/form-manager/v1.1/forms`, {
      language: language,
      skip : 0,
      take : 999999
    })
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      return error.response
    });
  },
  async getFormByID(id) {
    return get(`/v4/form-manager/v1.1/forms/${id}`)
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      return error.response
    });
  },
  getFormTextSubmit(language) {
    return get(`/v4/form-web/v1/forms/submit/message/${language}`)
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      return error.response
    });
  },
  async getAcceptTermsURL() {
    return get(`/v4/form-manager/v1.1/forms/page/terms-conditions`, {})
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        return error.response
      });
  },
}
